import storage from 'kv-storage-polyfill'
import store from '@/store'

export const loadedPersistedState = () => new Promise( resolve => {

  let interval = null

  interval = setInterval(() => {
    if (store.getters.isLoaded) {
      clearInterval(interval)
      resolve()
    }
  }, 100);

})

export const setStateMutation = (state, payload) => {
  Object.keys(payload).forEach(key => {
    state[key] = payload[key]
  })
}

const perssistPlugin = modules => async store => {

  await Promise.all(modules.map(async module => {
    const moduleState = await storage.get(module)

    if (moduleState) {
      store.commit(`${module}/setState`, moduleState)
    }

    return moduleState

  }))

  store.commit('loaded')

  store.subscribe((mutation, state) => {
    const { type } = mutation
    const [ module ] = type.split('/')

    if(modules.indexOf(module) === -1) {
      return
    }

    const moduleState = {
      ...state[module]
    }

    return storage.set(module, moduleState)

  })
}

export default perssistPlugin